import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle,
    TableRow, Table,
    TableHead,
    TableBody, Card,
    TableCell,
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import BankDetailsService from "./Locality/Service/bankDetailsService";
import ImageService from "./Locality/Service/imageService";
import * as Yup from 'yup';
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import requests from "./Locality/Service/httpService";
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
    input: {
        display: 'none',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

export default function BankDetails() {
    const tableHeaders = ['Bank Name', 'Account Holder Name', 'Account Number', 'IFSC Code', 'Branch Name', 'PAN Card', 'Cancelled Cheque', 'Status', 'Edit', 'Delete'];
    const classes = useStyles();
    const [bankDetailsList, setBankDetailsList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [panCardImage, setPanCardImage] = useState("");
    const [cancelledChequeImage, setCancelledChequeImage] = useState("");
    const [bankDetails, setBankDetails] = useState({
        bankName: '',
        accountHolderName: '',
        accountNumber: '',
        ifscCode: '',
        branchName: '',
        panCardCopy: '',
        cancelledCheque: '',
        status: true,
    });

    const validationSchema = Yup.object().shape({
        bankName: Yup.string().required('Bank Name is required'),
        accountHolderName: Yup.string().required('Account Holder Name is required'),
        accountNumber: Yup.string().required('Account Number is required'),
        ifscCode: Yup.string().required('IFSC Code is required'),
        branchName: Yup.string().required('Branch Name is required'),
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    useEffect(() => {
        getBankDetailsList();
        return () => {
            setBankDetailsList([]);
        };
    }, []);

    const getBankDetailsList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const profileId = userDetails.role === "admin" ? null : userDetails.profileId;
        
        BankDetailsService.getBankDetails({ profileRegistrationId: profileId }).then((res) => {
            setBankDetailsList(res);
        }).catch((err) => {
            console.error(err);
        });
    };

    const handleOpen = () => {
        setOpen(true);
        setPanCardImage("");
        setCancelledChequeImage("");
    };

    const handleClose = () => {
        setOpen(false);
        setBankDetails({
            bankName: '',
            accountHolderName: '',
            accountNumber: '',
            ifscCode: '',
            branchName: '',
            panCardCopy: '',
            cancelledCheque: '',
            status: true,
        });
        setPanCardImage("");
        setCancelledChequeImage("");
    };

    const editBankDetails = (bankDetail) => {
        const obj = JSON.parse(JSON.stringify(bankDetail));
        setBankDetails(obj);
        setPanCardImage(obj.panCardCopy || "");
        setCancelledChequeImage(obj.cancelledCheque || "");
        handleOpen();
    };

    const deleteBankDetails = (bankDetailDelete) => {
        if (window.confirm('Are you sure you want to delete this bank detail?')) {
            if (bankDetailDelete) {
                BankDetailsService.deleteBankDetails(bankDetailDelete).then((res) => {
                    getBankDetailsList();
                    alert("Bank Details Deleted Successfully.");
                }).catch((err) => {
                    alert("Error deleting bank details.");
                });
            }
        }
    };

    const uploadPanCard = (evt) => {
        const file = evt.target.files[0];
        if (!file) {
            alert("Please select a file to upload");
            return;
        }
        const formData = new FormData();
        formData.append('image', file);
        formData.append('imageName', file.name);
        
        ImageService.uploadImage(formData).then((res) => {
            const url = requests.baseURL();
            const image = res.filename;
            const final = `${url}/image/download/${image}`;
            setPanCardImage(final);
        }).catch((err) => {
            alert("Error uploading PAN card image.");
        });
    };

    const uploadCancelledCheque = (evt) => {
        const file = evt.target.files[0];
        if (!file) {
            alert("Please select a file to upload");
            return;
        }
        const formData = new FormData();
        formData.append('image', file);
        formData.append('imageName', file.name);
        
        ImageService.uploadImage(formData).then((res) => {
            const url = requests.baseURL();
            const image = res.filename;
            const final = `${url}/image/download/${image}`;
            setCancelledChequeImage(final);
        }).catch((err) => {
            alert("Error uploading cancelled cheque image.");
        });
    };

    const formik = useFormik({
        initialValues: bankDetails,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.profileRegistrationId = userDetails.profileId;
            values.panCardCopy = panCardImage || bankDetails.panCardCopy;
            values.cancelledCheque = cancelledChequeImage || bankDetails.cancelledCheque;

            if (bankDetails._id) {
                BankDetailsService.updateBankDetails(values).then((res) => {
                    handleClose();
                    getBankDetailsList();
                    resetForm();
                    alert("Bank Details Updated Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error updating bank details.");
                });
            } else {
                BankDetailsService.createBankDetails(values).then((res) => {
                    getBankDetailsList();
                    resetForm();
                    handleClose();
                    alert("Bank Details Added Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error adding bank details.");
                });
            }
        },
    });

    return (
        <>
            <PageTitle title="Bank Details" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(112, 57, 177)' }}> Add Bank Details
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Table className="mb-0">
                            <TableHead>
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bankDetailsList.slice(pg * rpg, pg * rpg + rpg).map((bankDetail) => (
                                    <TableRow key={bankDetail._id}>
                                        <TableCell className="pl-3 fw-normal">{bankDetail.bankName}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{bankDetail.accountHolderName}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{bankDetail.accountNumber}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{bankDetail.ifscCode}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{bankDetail.branchName}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {bankDetail.panCardCopy ? (
                                                <a href={bankDetail.panCardCopy} target="_blank" rel="noopener noreferrer">
                                                    <img height={50} width={50} src={bankDetail.panCardCopy} alt="PAN Card" />
                                                </a>
                                            ) : 'N/A'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {bankDetail.cancelledCheque ? (
                                                <a href={bankDetail.cancelledCheque} target="_blank" rel="noopener noreferrer">
                                                    <img height={50} width={50} src={bankDetail.cancelledCheque} alt="Cancelled Cheque" />
                                                </a>
                                            ) : 'N/A'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {bankDetail.status ? 'Active' : 'Inactive'}
                                        </TableCell>
                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editBankDetails(bankDetail)} />
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteBankDetails(bankDetail)} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            count={bankDetailsList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogTitle>{bankDetails._id ? 'Edit Bank Details' : 'Add Bank Details'}</DialogTitle>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="bankName"
                                    name="bankName"
                                    label="Bank Name"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.bankName}
                                    error={formik.touched.bankName && Boolean(formik.errors.bankName)}
                                    helperText={formik.touched.bankName && formik.errors.bankName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="accountHolderName"
                                    name="accountHolderName"
                                    label="Account Holder Name"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.accountHolderName}
                                    error={formik.touched.accountHolderName && Boolean(formik.errors.accountHolderName)}
                                    helperText={formik.touched.accountHolderName && formik.errors.accountHolderName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="accountNumber"
                                    name="accountNumber"
                                    label="Account Number"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.accountNumber}
                                    error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                                    helperText={formik.touched.accountNumber && formik.errors.accountNumber}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="ifscCode"
                                    name="ifscCode"
                                    label="IFSC Code"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.ifscCode}
                                    error={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)}
                                    helperText={formik.touched.ifscCode && formik.errors.ifscCode}
                                    inputProps={{ style: { textTransform: 'uppercase' } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="branchName"
                                    name="branchName"
                                    label="Branch Name"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.branchName}
                                    error={formik.touched.branchName && Boolean(formik.errors.branchName)}
                                    helperText={formik.touched.branchName && formik.errors.branchName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" style={{ marginBottom: 8, marginTop: 8 }}>
                                    PAN Card Copy (Upload)
                                </Typography>
                                <input
                                    accept="image/*,.pdf"
                                    className={classes.input}
                                    id="pan-card-upload"
                                    type="file"
                                    onChange={uploadPanCard}
                                />
                                <label htmlFor="pan-card-upload">
                                    <Button variant="outlined" component="span" size="small">
                                        Upload PAN Card
                                    </Button>
                                </label>
                                {panCardImage && (
                                    <div style={{ marginTop: 8 }}>
                                        <img src={panCardImage} alt="PAN Card" height={100} width={100} style={{ marginRight: 8 }} />
                                        <Button size="small" onClick={() => setPanCardImage("")}>Remove</Button>
                                    </div>
                                )}
                                {!panCardImage && bankDetails.panCardCopy && (
                                    <div style={{ marginTop: 8 }}>
                                        <img src={bankDetails.panCardCopy} alt="PAN Card" height={100} width={100} />
                                    </div>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" style={{ marginBottom: 8, marginTop: 8 }}>
                                    Cancelled Cheque / Bank Proof (Upload)
                                </Typography>
                                <input
                                    accept="image/*,.pdf"
                                    className={classes.input}
                                    id="cheque-upload"
                                    type="file"
                                    onChange={uploadCancelledCheque}
                                />
                                <label htmlFor="cheque-upload">
                                    <Button variant="outlined" component="span" size="small">
                                        Upload Cancelled Cheque
                                    </Button>
                                </label>
                                {cancelledChequeImage && (
                                    <div style={{ marginTop: 8 }}>
                                        <img src={cancelledChequeImage} alt="Cancelled Cheque" height={100} width={100} style={{ marginRight: 8 }} />
                                        <Button size="small" onClick={() => setCancelledChequeImage("")}>Remove</Button>
                                    </div>
                                )}
                                {!cancelledChequeImage && bankDetails.cancelledCheque && (
                                    <div style={{ marginTop: 8 }}>
                                        <img src={bankDetails.cancelledCheque} alt="Cancelled Cheque" height={100} width={100} />
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" color="primary" variant="contained">
                            {bankDetails._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}

